import React from 'react';
import './css/app.css';
import './css/animate.css';
import './css/bootstrap.css';
import { BrowserRouter as Router, Switch, Route, /* Link */ } from "react-router-dom";

// Seiten
import Start from './seiten/index';
import Kontakt from './seiten/contact';
import Impressum from './seiten/impressum';
import Datenschutz from './seiten/datenschutz';
import Regionalitet from './seiten/regionalitet';
import Bestellung from './seiten/bestellung';
import BestellForm from './seiten/bestellForm';
import Alergene from './seiten/alergene';

import Navbar from './components/navbar';
import Footer from './components/footer';

// Elemente
// import Icon from './components/icons';

import { Dialog, DialogTitle, DialogContent, Divider, DialogActions, Button } from '@material-ui/core';


class App extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      mobileVersion: false,
      open: false
    };
  }

  componentDidMount() {
    window.onresize = (e) => {
      if (e.target.innerWidth < 1000) {
        if (this.state.mobileVersion === true) {
          return;
        }
        this.setState({ mobileVersion: true });
      } else {
        if (this.state.mobileVersion === false) {
          return;
        }
        this.setState({ mobileVersion: false });
      }
    };

    if (window.innerWidth < 1000) {
      this.setzeState({ mobileVersion: true })
    }


  }

  setzeState(state) {
    this.setState(state);
  }


  render() {
    return (<>


      <Dialog
        className="shadow-sm pt-5 pb-5"
        open={this.state.open}
        //        maxWidth={"xs"}
        fullWidth={true}
        fullScreen={this.state.mobileVersion}
        onClose={() => this.setState({ open: false })}
      >
        <DialogTitle>Wichtige Information</DialogTitle>
        <Divider className="ml-3 mr-3" />

        <DialogContent >
          <p>Liebe Gäste,</p>

          <p>unsere Pizzastation ist vorübergehend geschlossen. Die Burger- und Salatstation stehen Ihnen selbstverständlich wie gewohnt zur Verfügung.</p>

          <p>Vielen Dank für Ihr Verständnis.</p>

          <p>Liebe Grüße Teigwerk-Team</p>

        </DialogContent>
        <DialogActions>
          <Button color="secondary" variant="outlined" onClick={() => this.setState({ open: false })}>schließen</Button>
        </DialogActions>
      </Dialog >


      <Router>
        <Navbar mobileVersion={this.state.mobileVersion} />
        <Switch>
          <Route path="/impressum">
            <Impressum mobileVersion={this.state.mobileVersion} />
          </Route>
          <Route path="/datenschutz">
            <Datenschutz mobileVersion={this.state.mobileVersion} />
          </Route>
          <Route path="/kontakt">
            <Kontakt mobileVersion={this.state.mobileVersion} />
          </Route>
          <Route path="/regionalitet">
            <Regionalitet mobileVersion={this.state.mobileVersion} />
          </Route>
          <Route path="/bestellung">
            <Bestellung mobileVersion={this.state.mobileVersion} />
          </Route>
          <Route path="/bestellForm">
            <BestellForm {...this.props} mobileVersion={this.state.mobileVersion} />
          </Route>
          <Route path="/alergene">
            <Alergene mobileVersion={this.state.mobileVersion} />
          </Route>
          <Route path="/">
            <Start mobileVersion={this.state.mobileVersion} />
          </Route>
        </Switch>
        <Footer mobileVersion={this.state.mobileVersion} />
      </Router>
    </>
    );
  }

}

export default App;